"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var react_1 = __importDefault(require("react"));
var spinnerBem = (0, BemBuilder_1.default)("spinner");
function IconSpinner(_a) {
    var IconComponent = _a.icon, iconSize = _a.iconSize, text = _a.text;
    return (react_1.default.createElement("div", { className: spinnerBem("root") },
        react_1.default.createElement("div", { className: spinnerBem("spinner-root") },
            react_1.default.createElement("svg", { className: spinnerBem("spinner"), width: "82", height: "82", fill: "none", viewBox: "0 0 82 82" },
                react_1.default.createElement("circle", { cx: "41", cy: "41", r: "38.696", stroke: "#81A2B2", strokeOpacity: ".25", strokeWidth: "3" }),
                react_1.default.createElement("path", { stroke: "url(#a)", strokeLinecap: "round", strokeWidth: "3", d: "M79.695 41C79.695 19.63 62.371 2.304 41 2.304S2.304 19.63 2.304 41 19.63 79.696 41 79.696" }),
                react_1.default.createElement("defs", null,
                    react_1.default.createElement("linearGradient", { id: "a", x1: "79.695", x2: "2.304", y1: "79.696", y2: "79.696", gradientUnits: "userSpaceOnUse" },
                        react_1.default.createElement("stop", { stopColor: "#FF6161" }),
                        react_1.default.createElement("stop", { offset: ".271", stopColor: "#FFB961" }),
                        react_1.default.createElement("stop", { offset: ".536", stopColor: "#00A99D" }),
                        react_1.default.createElement("stop", { offset: ".773", stopColor: "#33AFFF" }),
                        react_1.default.createElement("stop", { offset: "1", stopColor: "#716BF1" })))),
            react_1.default.createElement(IconComponent, { className: spinnerBem("icon"), size: iconSize || icons_1.IconSize.Large })),
        text && (react_1.default.createElement(kaleidoscope_1.Text, { className: spinnerBem("text"), strong: true, secondary: true, size: "s", align: "center" }, text))));
}
exports.default = IconSpinner;
